import routesNames from "../utils/router/routesNames";

export default function () {
    return [
        {
            title: 'SIDEBAR.DASHBOARD',
            to: {
                name: routesNames.DASHBOARD,
            },
            htmlBefore: '<i class="fas fa-desktop"></i>',
            htmlAfter: '',
        },
        {
            title: 'SIDEBAR.METRICS',
            htmlBefore: '<i class="fas fa-chart-line"></i>',
            items: [
                {
                    title: "SIDEBAR.HISTORICS",
                    to: {
                        name: routesNames.HISTORICS
                    }
                },
                {
                    title: "SIDEBAR.DAILY_REPORT",
                    to: {
                        name: routesNames.DAILY_REPORT,
                    }
                }],

        },
        {
            title: 'SIDEBAR.ANALYTICS',
            htmlBefore: '<i class="fas fa-chart-bar"></i>',
            items: [
                {
                    title: "SIDEBAR.RISK_ANALYSIS",
                    to: {
                        name: routesNames.RISK_ANALYSIS
                    }
                }]
        },
        {
            title: 'SIDEBAR.CONFIGS',
            htmlBefore: '<i class="fas fa-cog"></i>',
            to: {
                name: routesNames.CONFIGS,
            },
        },
        {
            title: 'SIDEBAR.INSURANCE',
            isInsurance: true,
            htmlBefore: '<i class="fas fa-shield-alt"></i>',
            to : {
                name: routesNames.INSURANCE
            }
            
        }
    ];
}
